import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CourseOnlineList from './course_online_list';
import CourseOnlineDetail from './course_online_detail';

class CourseOnline extends Component {
  componentDidMount(){
  }
  render() {
    //console.log(this.context);
    var params = this.context.router.route.match.params;
    var view;
    if(params.action===undefined){
      view = <CourseOnlineList/>;
    }else{
      if(params.id===undefined){
        view = <CourseOnlineDetail/>;
      }else{
        view = <CourseOnlineDetail action={params.action}/>;
      }
    }
    return (
      <div className="page-wrapper">{view}</div>
    );
  }
}

CourseOnline.contextTypes = {
  router: PropTypes.object
};

export default CourseOnline;
